import React, { useState } from "react";
import testSeriesData from "../data/test-series/testSeriesdata";
//import { toast } from "react-toastify";
import TestSeriesPopup from "../components/testSeries/TestSeriesPopup";

export default function TestSeries() {
  const [showPopup, setShowPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");

  const handleOpenPopup = (title) => {
    setPopupTitle(title);
    setShowPopup(true);
  };

  const handleClosePopup = () => setShowPopup(false);

  return (
    <div>
      {testSeriesData.map((series) => (
        <section
          key={series.id}
          id={series.id}
          className="w-full bg-gray-50 py-12 px-6"
        >
          <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden p-6 md:p-10">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                {series.title}
              </h2>
              {series.description && (
                <p className="text-gray-600 mt-3 max-w-3xl mx-auto">
                  {series.description}
                </p>
              )}
            </div>

            <div className="flex justify-center mb-10">
              <img
                src={series.image}
                alt={series.title}
                className="w-full md:w-5/6 h-64 md:h-96 object-cover rounded-xl shadow-md"
              />
            </div>

            <div className="flex flex-col gap-8">
              {series.programs.map((program) => (
                <div
                  key={program.name}
                  className="p-6 border rounded-xl bg-gray-50 hover:shadow-md transition"
                >
                  <h3
                    className={`flex items-center gap-2 text-xl font-semibold text-${program.color}-700 mb-2`}
                  >
                    {program.icon} {program.name}
                  </h3>
                  <ul className="list-disc list-inside text-gray-700 space-y-1">
                    {program.details.map((d, i) => (
                      <li key={i}>{d}</li>
                    ))}
                  </ul>

                  <button
                    onClick={() => handleOpenPopup(program.name)}
                    className={`mt-5 w-full md:w-auto px-6 py-2 rounded-full text-white transition bg-${program.color}-700 hover:bg-${program.color}-800`}
                  >
                    Enquire {program.name.split(":")[0]}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      <TestSeriesPopup
        showPopup={showPopup}
        onClose={handleClosePopup}
        title={popupTitle}
      />
    </div>
  );
}
